import { Box } from "@mui/material";

function BottomFullWidthButtonContainer({ sx = [], ...props }) {
  return (
    <Box
      sx={[
        {
          position: "fixed",
          maxWidth: 600,
          ml: "-24px",
          bottom: 0,
          width: "100%",
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          bgcolor: "common.white",
          py: "16px",
          px: "24px",
          pb: `calc(env(safe-area-inset-bottom) + 16px )`,
          boxShadow: (theme) => theme.shadows[2],
          borderTopLeftRadius: "20px",
          borderTopRightRadius: "20px",
        },
        ...(Array.isArray(sx) ? sx : [sx]),
      ]}
    >
      {props.children}
    </Box>
  );
}

export default BottomFullWidthButtonContainer;
